import Vue from "vue";
import getBaseUrl from "../config/baseUrl";

Vue.prototype.$news = new Vue({
  methods: {
    get(language = "en", filters, limit = 15) {
      let lang = language;

      if (lang === "pt") {
        lang = "pt-br";
      }

      let url = `${getBaseUrl()}news/${lang}?limit=${limit}`;

      if (filters?.page) {
        url += `&page=${filters.page}`;
      }

      if (filters?.regional) {
        url += `&office=${filters.regional}`;
      }

      return new Promise((resolve, reject) => {
        this.$http
          .get(url)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },

    getSingle(language, slug) {
      let lang = language;

      if (lang === "pt") {
        lang = "pt-br";
      }

      return new Promise((resolve, reject) => {
        this.$http
          .get(`${getBaseUrl()}news/${lang}/${slug}`)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },
  },
});
